// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: var(--bg-secondary);
  color: var(--text-primary);
  margin-top: 4rem;
  border-top: 1px solid var(--border-primary);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2.5rem 2rem 1rem;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  color: var(--text-primary);
  font-weight: 700;
  font-size: 1.1rem;
}

.footer-logo-img {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  object-fit: contain;
}

.footer-tagline {
  color: var(--text-secondary);
  font-size: 0.85rem;
  line-height: 1.5;
  margin: 0;
}

.footer-section h4 {
  color: var(--text-primary);
  font-size: 0.9rem;
  font-weight: 700;
  margin: 0 0 0.75rem;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 0.4rem;
}

.footer-link {
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.85rem;
  transition: color 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.footer-link:hover {
  color: var(--accent-primary);
}

.footer-social-icon {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  object-fit: contain;
}

.footer-bottom {
  border-top: 1px solid var(--border-primary);
  padding-top: 1rem;
  text-align: center;
}

.footer-bottom p {
  color: var(--text-tertiary);
  font-size: 0.8rem;
  margin: 0;
}

@media (max-width: 680px) {
  .footer-container {
    padding: 2rem 1rem 1rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,2CAA2C;EAC3C,8DAA8D;AAChE;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;AACF","sourcesContent":[".footer {\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n  margin-top: 4rem;\r\n  border-top: 1px solid var(--border-primary);\r\n  transition: background-color 0.3s ease, border-color 0.3s ease;\r\n}\r\n\r\n.footer-container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 2.5rem 2rem 1rem;\r\n}\r\n\r\n.footer-content {\r\n  display: grid;\r\n  grid-template-columns: 2fr 1fr 1fr;\r\n  gap: 2rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.footer-brand {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.footer-logo {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  text-decoration: none;\r\n  color: var(--text-primary);\r\n  font-weight: 700;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.footer-logo-img {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 6px;\r\n  object-fit: contain;\r\n}\r\n\r\n.footer-tagline {\r\n  color: var(--text-secondary);\r\n  font-size: 0.85rem;\r\n  line-height: 1.5;\r\n  margin: 0;\r\n}\r\n\r\n.footer-section h4 {\r\n  color: var(--text-primary);\r\n  font-size: 0.9rem;\r\n  font-weight: 700;\r\n  margin: 0 0 0.75rem;\r\n}\r\n\r\n.footer-links {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.footer-links li {\r\n  margin-bottom: 0.4rem;\r\n}\r\n\r\n.footer-link {\r\n  color: var(--text-secondary);\r\n  text-decoration: none;\r\n  font-size: 0.85rem;\r\n  transition: color 0.2s ease;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.footer-link:hover {\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.footer-social-icon {\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 4px;\r\n  object-fit: contain;\r\n}\r\n\r\n.footer-bottom {\r\n  border-top: 1px solid var(--border-primary);\r\n  padding-top: 1rem;\r\n  text-align: center;\r\n}\r\n\r\n.footer-bottom p {\r\n  color: var(--text-tertiary);\r\n  font-size: 0.8rem;\r\n  margin: 0;\r\n}\r\n\r\n@media (max-width: 680px) {\r\n  .footer-container {\r\n    padding: 2rem 1rem 1rem;\r\n  }\r\n\r\n  .footer-content {\r\n    grid-template-columns: 1fr;\r\n    gap: 1.5rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
